import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut } from "lucide-react";

export default function Header() {
  const { t, language, toggleLanguage } = useLanguage();
  const { admin, logout } = useAuth();
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <header className="px-4 md:px-12 py-4 border-b border-stone-200 bg-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
          <img 
            src="/lab-logo.png"
            alt="Learning Brain Lab"
            className="h-10 w-10 object-contain"
            style={{ background: "transparent" }}
          />
          <span className="font-outfit font-semibold text-lg text-forest-900 hidden sm:block">
            Learning Brain Lab
          </span>
        </Link>
        
        <nav className="flex items-center gap-1 md:gap-2">
          <Link to="/">
            <Button 
              variant="ghost" 
              size="sm"
              className={`text-sm ${isActive("/") ? "text-forest-800 bg-forest-50" : "text-stone-600 hover:text-forest-800"}`}
            >
              {t("nav.home")}
            </Button>
          </Link>
          {/* Studien hidden for now
          <Link to="/studien">
            <Button 
              variant="ghost" 
              size="sm"
              className={`text-sm ${isActive("/studien") ? "text-forest-800 bg-forest-50" : "text-stone-600 hover:text-forest-800"}`}
            >
              {t("nav.studies")}
            </Button>
          </Link>
          */}
          <Link to="/newsletters">
            <Button 
              variant="ghost" 
              size="sm"
              className={`text-sm ${isActive("/newsletters") ? "text-forest-800 bg-forest-50" : "text-stone-600 hover:text-forest-800"}`}
            >
              Newsletter
            </Button>
          </Link>
          
          {/* Language Toggle */}
          <Button 
            variant="outline" 
            size="sm"
            onClick={toggleLanguage}
            className="rounded-full px-3 text-sm font-medium border-stone-300"
            data-testid="language-toggle"
          >
            {language === "de" ? "EN" : "DE"}
          </Button>
          
          {admin ? (
            <>
              <Link to="/admin">
                <Button 
                  variant="ghost" 
                  size="sm"
                  className="text-sm text-stone-600 hover:text-forest-800"
                >
                  {t("nav.admin")}
                </Button>
              </Link>
              <Button
                variant="ghost"
                size="sm"
                onClick={logout}
                className="text-stone-600"
              >
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            <Link to="/admin/login">
              <Button 
                variant="ghost" 
                size="sm"
                className="text-sm text-stone-600 hover:text-forest-800 hidden md:inline-flex"
              >
                {t("nav.admin")}
              </Button>
            </Link>
          )}
          
          <Link to="/buchen">
            <Button 
              size="sm"
              className="bg-forest-800 hover:bg-forest-900 text-white rounded-full px-4 text-sm"
              data-testid="book-btn-header"
            >
              {t("nav.bookAppointment")}
            </Button>
          </Link>
        </nav>
      </div>
    </header>
  );
}
